// WebFs object store replaces the AbortError of its own fetch timeout with this text.
export const WEBFS_FETCH_ABORTED_MESSAGE = 'Request was aborted (timeout or cancelled)';
